/**
 * Shared CSS reset rules used by both AppShell and ChromelessLayout.
 * Keep them in one place so the two layouts never drift out of sync.
 */
export const globalCss = [
  'html,body{color:var(--font-color,#212b36);font-size:var(--font-size-base,16px);font-weight:400;line-height:1.2;overscroll-behavior-y:none;height:100%;margin:0;padding:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}',
  ':focus{outline:none}',
  "[type='search']{-webkit-appearance:textfield;outline-offset:-2px}",
  "[type='search']::-webkit-search-decoration{-webkit-appearance:none}",
  'iframe{border:none}',
  '*{scrollbar-width:thin;scrollbar-color:rgba(0,0,0,0.5) transparent}',
  '::-webkit-scrollbar{width:10px;height:10px}',
  '::-webkit-scrollbar-track{border-radius:10px;background-color:transparent}',
  '::-webkit-scrollbar-thumb{border-radius:10px;border:2px solid #fff;transition:all 0.3s ease-in-out;background-color:transparent}',
  '.scrollbar-light,.scrollbar-light *{scrollbar-color:rgba(255,255,255,0.5) transparent}',
  '.scrollbar-light::-webkit-scrollbar-thumb,.scrollbar-light *::-webkit-scrollbar-thumb{background-color:rgba(255,255,255,0.5);border-color:transparent}',
  'button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}',
  'ul,ol,dl{margin:0;padding:0}',
  'a{text-decoration:none}',
  'a:hover{text-decoration:none}',
  'audio,canvas,iframe,img,svg,video{vertical-align:middle}',
  '[hidden],template{display:none}',
];
